import { Component, Host, Prop, State, h } from '@stencil/core';
import { SwiperOptions } from 'swiper/types/swiper-options';

@Component({
  tag: 'lg-gallery',
  styleUrl: 'lg-gallery.css',
  shadow: false,
})
export class LgGallery {
  @State() currentSlide = 1;
  @State() numSlides: number;
  @Prop() slidesPerView = 1;
  @Prop() delay = 0;
  private swiperEl?: any;
  private nextEl?: HTMLElement;
  private prevEl?: HTMLElement;
  private caption?: string;

  componentDidRender() {
    const swiperOptions: SwiperOptions = {
      loop: true,
      autoplay: this.delay > 0 ?
        { delay: this.delay,
          pauseOnMouseEnter: true,
          disableOnInteraction: false } :
        false,
      centeredSlides: true,
      navigation: {
        nextEl: this.nextEl,
        prevEl: this.prevEl,
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
        },
        640: {
          slidesPerView: this.slidesPerView,
        },
      },
      keyboard: true,
      spaceBetween: this.slidesPerView > 1 ? -50 : 0,
      on: {
        slideChange: () => {
          this.currentSlide = this.swiperEl.swiper?.realIndex + 1;
          this.caption = this.swiperEl.swiper?.slides[this.swiperEl.swiper?.activeIndex].querySelector('figcaption')?.textContent;
        },
      },
    };

    Object.assign(this.swiperEl, swiperOptions);
    this.numSlides = this.swiperEl.swiper?.slides.length;
    this.swiperEl.initialize();
  }

  render() {
    return (
      <Host>
        <div>
          <swiper-container init="false" ref={el => (this.swiperEl = el)}>
            <slot></slot>
          </swiper-container>
          <div class="row mt-md">
            <div class="col-12 col-sm-8 col-xl-6 d-flex gap-md align-items-start order-sm-2">
              <div class="pagination">
                <span class="h1 mb-0 text-primary">{String(this.currentSlide)}</span>
                <span class="h1 mb-0 text-primary">/{String(this.numSlides)}</span>
              </div>
              <div>
                <p class="text-sm mt-2xs mt-lg-xs mb-0">{this.caption}</p>
              </div>
            </div>
            <div class="col-12 col-sm-4 col-xl-6 d-flex gap-md gap-md-xl align-items-start mt-md mt-sm-0 order-sm-1">
              <button ref={el => (this.prevEl = el)} class="btn btn-primary prev-btn d-inline-flex justify-content-center align-items-center p-0">
                <lg-icon name="chevron-left"></lg-icon>
              </button>
              <button ref={el => (this.nextEl = el)} class="btn btn-primary next-btn d-inline-flex justify-content-center align-items-center p-0">
                <lg-icon name="chevron-right"></lg-icon>
              </button>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
